export const FETCH_ADD_ROLES_REQUEST = 'FETCH_ADD_ROLES_REQUEST'
export const FETCH_ADD_ROLES_SUCCESS = 'FETCH_ADD_ROLES_SUCCESS'
export const FETCH_ADD_ROLES_FALUIRE = 'FETCH_ADD_ROLES_FALUIRE'
